const initWorkCardAccordion = () => {
  let accordions = document.querySelectorAll('.work-card__accordion');

  const closeAllAccordions = () => {
    accordions.forEach((accordion) => {
      let desc = accordion.nextElementSibling;
      accordion.classList.remove('active');
      desc.style.maxHeight = null;
    });
  };

  for (let i = 0; i < accordions.length; i++) {
    accordions[i].addEventListener('click', function () {
      if (this.classList.contains('active')) {
        this.classList.remove('active');
        let desc = this.nextElementSibling;
        desc.style.maxHeight = null;
      } else {
        closeAllAccordions();
        let desc = this.nextElementSibling;
        this.classList.toggle('active');
        desc.style.maxHeight = this.classList.contains('active') ? desc.scrollHeight + 'px' : null;
      }
    });
  }
};

export { initWorkCardAccordion };
